import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../../components/HeaderFFF'
import Header from '../../../components/Header'
import Footer from "../../../components/Footer";
import { Link } from 'react-router-dom';
import '../../../styles/injury.css'

export default function BicycleAccidents() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return(
            <>
            {isMobile ? <Header /> : <HeaderFFF />}
        <div id="injury">
            <div id="fields-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Bicycle Accidents</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
                </div>
            <div className="pi-text">
                <p><b>Bicycle accidents</b> are very common in the GTA, especially as roads are often unsafe and
drivers can be neglectful of the safety of cyclists. Bicycles are a great, inexpensive mode of
transportation, but often they are involved in injuries that are costly, disabling, and traumatic.
Brain injuries and disabilities are not uncommon. Cyclist deaths are also much more frequent
than they should be.<br/><br/>
<span className="pi-sub-section">Common Causes of Bicycle Accidents</span><br/><br/>
The following is a list of common causes of bicycle accident injuries for which you can pursue
bicycle accident injury compensation with the help of a talented and experienced bicycle
accident injury lawyer in Ontario:
<ul>
<li> Motorist emerging into path of cyclist</li>
<li>Motorist turning across path of cyclist</li>
<li> Cyclist fails to pay attention to traffic signs, signals, or rules</li>

<li> Cyclist fails to use appropriate speed, skill, or technique on the road</li>
<li> Cyclist and motorist going straight ahead</li>
<li> Cyclist turning right from a major or minor road</li>
<li> Child cyclist playing or riding too fast</li>
<li> Bicycle has manufacturing or design defects that cause it to crash</li>
</ul>
Types of Bicycle Accident Personal Injury Cases We Handle
At CLV, our bicycle injury lawyers can handle any of the following bicycle accident injury claims:
<ul>
<li> Back and spinal cord injuries</li>
<li> Amputations</li>
<li> Back Injuries</li>
<li> Fractures and Broken Bones</li>
<li> Abrasions/Road Rash</li>
<li>Partial or Permanent Disabilities</li>
<li> Internal Bleeding</li>
<li>Wrongful Death</li>
</ul>
Compensation for Your Bicycle Injuries
If you have suffered either minor or severe bicycle accident injuries due to the negligence of a
motor vehicle, you are entitled to the following bicycle accident injury compensation:
<ul>
<li> Attendant Care Benefits</li>
<li> Earnings Replacements</li>
<li> Occupational Therapy</li>
<li> Vocational Rehabilitation</li>
<li> Disability Benefits</li>
<li> Housekeeping and Home Care</li>
</ul>
Bicycle Accident Lawyers
CLV has an incredible track record when it comes to successfully filing bicycle accident injury
claims and defending clients injured in bicycle accidents in the GTA and surrounding areas. We
will work hard to ensure you do not suffer simply for riding a bicycle. We are equipped to handle
complex legal and insurance issues arising from your bicycle accident.<br/><br/>
To arrange a Free consultation, <Link to="/contact-us">contact us</Link> today.</p>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
                </div>
        </div>
            <Footer />
        </>
        );
}